import LiveEvent from "../../components/live/live";
import Modal from "../../components/modal/modal";

new LiveEvent('click', '[data-modal]', function openModal(e) {
  e.preventDefault();
  let link = this;
  const theme = link.dataset.theme ? link.dataset.theme : 'default';
  let modal = new Modal(this, {
    closerText: '',
    theme,
    onFormSuccess: function () {
      const submitEvent = new Event('modal-form:success');
      submitEvent.element = link;
      document.dispatchEvent(submitEvent);
    },
  });
  return false;
});
